import { useState } from "react"
import Modal from "react-modal"

import { Button, Section, Title, WysiwygText } from "components/shared"

import { CloseIcon } from "assets/icons"

const Pricing = ({ id, description, descriptionTwo, packageDescription }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Section id={id} className="!pt-20" contentClassName="space-y-8" padding="lg" animate>
        <Title title="Treatment Cost" pretitle="Pricing" size="sm" center animate />
        <WysiwygText className=" max-w-[1000px] mx-auto text-center" text={description} animate />
        {packageDescription && (
          <div className="flex justify-center">
            <Button isLink onClick={() => setIsOpen(true)} className="underline !font-semibold" animate>
              View Full Package
            </Button>
          </div>
        )}
        {descriptionTwo && <WysiwygText className=" max-w-[1000px] mx-auto text-center" text={descriptionTwo} animate />}
      </Section>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        portalClassName="standard-modal"
        bodyOpenClassName="body-standard-modal-open"
      >
        <div className="flex justify-between">
          <h3 className="text-3xl">Full Package</h3>
          <button onClick={() => setIsOpen(false)}>
            <CloseIcon width={32} height={32} />
          </button>
        </div>
        <div className="mt-5 space-y-8 flex flex-col items-center">
          <WysiwygText text={packageDescription} />
        </div>
      </Modal>
    </>
  )
}

export default Pricing
